import React from 'react';

import { UserDetail } from '@atom/types/user';

export enum View {
  INFO = 'INFO',
  BUDGETS = 'BUDGETS',
  PERMISSIONS = 'PERMISSIONS',
  CERTIFICATIONS = 'CERTIFICATIONS',
  WORK = 'WORK',
  SETTINGS = 'SETTINGS',
  ROLES = 'ROLES',
  FILES = 'FILES',
  GROUPS = 'GROUPS',
}

interface Context {
  user: UserDetail;
  activeView: View;
  setActiveView: (view: View) => void;
  loading: boolean;
  refetch: () => Promise<any>;
}

export const initialState: Context = {
  activeView: View.INFO,
  setActiveView: () => {},
  // @ts-ignore
  user: {},
  loading: false,
  refetch: () => Promise.resolve({}),
};

const UserContext = React.createContext<Context>(initialState);

export default UserContext;
